import { List, Typography } from "@mui/material";

import LoadingIndicator from "../../Common/LoadingIndicator/LoadingIndicator";

import EntityUsersListItem from "./EntityUsersListItem";
import EntityUsersTableHeader from "./EntityUsersTableHeader";

export default function EntityUsersTable({ data, isLoading }) {
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data || data.length === 0) {
    return <Typography className="text-center">No users</Typography>;
  }

  return (
    <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-y-auto px-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <EntityUsersTableHeader />
      <List className="flex h-full flex-col gap-4" disablePadding>
        {data.map((user) => <EntityUsersListItem key={user.id} data={user} />)}
      </List>
    </div>
  );
}
